import axios from "axios";
import he from "he";

const API_URL = process.env.REACT_APP_API_Link;

const headers = {
  "Content-Type": "multipart/form-data",
};

const headers2 = {
  "Content-Type": "application/json",
};

const loginAdmin = (values) => {
  return axios.post(
    API_URL + "admin-login",
    {
      username: values.username,
      password: values.password,
    },
    {
      headers: headers2,
    }
  );
};

const forgotPass = (values) => {
  return axios.post(
    API_URL + "admin-forgot",
    {
      email: values.email,
    },
    {
      headers: headers2,
    }
  );
};

const getCounts = () => {
  return axios.get(
    API_URL + "all-picktrip-counters",

    {
      headers: headers2,
    }
  );
};

const latestOrder = () => {
  return axios.get(
    API_URL + "latest-users",

    {
      headers: headers2,
    }
  );
};
const orderArchive = (adminId, orderId) => {
  return axios.put(
    API_URL + `archive-order/${orderId}`,
    {
      adminId: adminId,
    },
    {
      headers: headers2,
    }
  );
};

const getProfile = (accesstoken) => {
  return axios.get(
    API_URL + "profile",

    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accesstoken}`,
      },
    }
  );
};

const profileUpdate = (values, id) => {
  return axios.put(
    API_URL + `profile/${id}`,
    {
      email: values.email,
      password: values.old_password,
      new_password: values.password,
    },
    {
      headers: headers2,
    }
  );
};

const getWebsiteInfo = () => {
  return axios.get(
    API_URL + "website",

    {
      headers: headers2,
    }
  );
};

const websiteUpdate = (values) => {
  return axios.put(
    API_URL + "website",
    {
      email: values.email,
      phone: values.phone,
    },
    {
      headers: headers2,
    }
  );
};

const getAllYears = () => {
  return axios.get(API_URL + `list-years`, {
    headers: headers2,
  });
};

const deletSingleFile = (id, admin_id) => {
  return axios.delete(API_URL + "file/" + id, {
    headers: headers2,
    data: {
      adminId: admin_id,
    },
  });
};
const deletAllFiles = (admin_id) => {
  return axios.delete(API_URL + "files", {
    headers: headers2,
    data: {
      adminId: admin_id,
    },
  });
};

const getUsers = (page, limit, values, status, year) => {
  return axios.get(
    API_URL +
      `users/${year}/${status}?limit=${limit}&page=${page}${
        values?.fieldtype && values?.searchval
          ? "&" + values.fieldtype + "=" + values.searchval
          : ""
      }`,
    {
      headers: headers2,
    }
  );
};
const deletSingleOrders = (id, admin_id) => {
  return axios.delete(API_URL + "user/" + id, {
    headers: headers2,
    data: {
      adminId: admin_id,
    },
  });
};
const deletAllOrders = (admin_id) => {
  return axios.delete(API_URL + "users", {
    headers: headers2,
    data: {
      adminId: admin_id,
    },
  });
};
const deletSingleNote = (id, admin_id) => {
  return axios.delete(API_URL + "note/" + id, {
    headers: headers2,
    data: {
      adminId: admin_id,
    },
  });
};
const archiveAllOrders = (admin_id) => {
  return axios.get(API_URL + "archive-all-orders", {
    headers: headers2,
    data: {
      adminId: admin_id,
    },
  });
};

const getOrdersById = (id) => {
  return axios.get(
    API_URL + "order/" + id,

    {
      headers: headers2,
    }
  );
};

const updateUserById = (values, adminId, id, choices) => {
  return axios.put(
    API_URL + `order/${id}`,
    {
      fname: values.First,
      lname: values.Last,
      address: values.address,
      city: values.City,
      state: values.State,
      zip: values.Zip,
      issuance: values.issuance,
      alternative_date: values.alternativeDate,
      alternative_destination: values.altDestination,
      booking_agent: values.agent,
      certificate_cost: values.certiCost,
      certificate_status: values.CertiStatus,
      destination: values.destination,
      email: values.email,
      expiration: values.Expiration,
      fullfilled_cost: values.fulfilCost,
      package_description: values.pkgDiscription,
      phone: values.phone,
      postmark_date: values.postmarkDate,
      requested_date: values.requestedDate,
      traveller_citizenship: values.TrCitizen,
      traveller_dob: values.TrDob,
      traveller_fname: values.TRFirst,
      traveller_lname: values.TrLast,
      traveller_upsells: values.TrUpsells,
      notes: values.addNotes,
      adminId: adminId,
    },
    {
      headers: headers2,
    }
  );
};

// voucher apis

const getVouchers = (page, limit, values, status, year) => {
  return axios.get(
    API_URL +
      `vouchers/${year}/${status}?limit=${limit}&page=${page}${
        values?.fieldtype && values?.searchval
          ? "&" + values.fieldtype + "=" + values.searchval
          : ""
      }`,
    {
      headers: headers2,
    }
  );
};
const deletSingleVouchers = (id, admin_id) => {
  return axios.delete(API_URL + "voucher-pyt/" + id, {
    headers: headers2,
    data: {
      adminId: admin_id,
    },
  });
};

const deleteCertificatesByType = (type, admin_id, job) => {
  return axios.delete(API_URL + "certificates/" + type + "/" + job, {
    headers: headers2,
    data: {
      adminId: admin_id,
    },
  });
};

const voucherArchive = (adminId, orderId) => {
  return axios.put(
    API_URL + `archive-voucher/${orderId}`,
    {
      adminId: adminId,
    },
    {
      headers: headers2,
    }
  );
};
const voucherUnArchive = (adminId, orderId) => {
  return axios.put(
    API_URL + `unarchive-voucher/${orderId}`,
    {
      adminId: adminId,
    },
    {
      headers: headers2,
    }
  );
};

const updateVoucherById = (values, adminId, id) => {
  return axios.put(
    API_URL + `voucher-pyt/${id}`,
    {
      company: values.Company,
      job: values.Job,
      certificate: values.Certificate,
      expiration: values.Expiration,
      concatenated: values.Concatenated,
      amount: values.Amount,
      shipCost: values.shipCost,
      shipped: values.Shipped,
      received: values.Received,
      fulfilled: values.Fulfilled,
      fname: values.First,
      lname: values.Last,
      street: values.Street,
      city: values.City,
      state: values.State,
      zip: values.Zip,
      issuance: values.issuance,
      adminId: adminId,
      choice01: values.choice1,
      choice02: values.choice2,
      choice03: values.choice3,
      choice04: values.choice4,
      choice05: values.choice5,
      choice06: values.choice6,
      choice07: values.choice7,
      choice08: values.choice8,
      choice09: values.choice9,
      choice10: values.choice10,
      choice11: values.choice11,
      choice12: values.choice12,
      choice13: values.choice13,
      choice14: values.choice14,
      choice15: values.choice15,
      choice16: values.choice16,
      choice17: values.choice17,
      choice18: values.choice18,
      choice19: values.choice19,
      choice20: values.choice20,
      choice21: values.choice21,
      choice22: values.choice22,
      choice23: values.choice23,
      choice24: values.choice24,
      choice25: values.choice25,
    },
    {
      headers: headers2,
    }
  );
};

// EMAILS APIS
const getEmails = (page, limit, values) => {
  return axios.get(
    API_URL +
      `emails?limit=${limit}&page=${page}${
        values?.fieldtype && values?.searchval
          ? "&" + values.fieldtype + "=" + values.searchval
          : ""
      }`,
    {
      headers: headers2,
    }
  );
};
const deletSingleEmail = (id, admin_id) => {
  return axios.delete(API_URL + "email/" + id, {
    headers: headers2,
    data: {
      adminId: admin_id,
    },
  });
};
const deletAllEmail = (admin_id) => {
  return axios.delete(API_URL + "emails", {
    headers: headers2,
    data: {
      adminId: admin_id,
    },
  });
};
const getEmailById = (id) => {
  return axios.get(
    API_URL + "email/" + id,

    {
      headers: headers2,
    }
  );
};
const updateEmailById = (email, id, adminId) => {
  return axios.put(
    API_URL + `email/${id}`,
    {
      email: email,
      adminId: adminId,
    },
    {
      headers: headers2,
    }
  );
};

const addEmail = (email, adminId) => {
  return axios.post(
    API_URL + `email`,
    {
      email: email,
      adminId: adminId,
    },
    {
      headers: headers,
    }
  );
};

const getVoucherById = (id) => {
  return axios.get(
    API_URL + "get-voucher/" + id,

    {
      headers: headers2,
    }
  );
};

// job api

const getJobss = (page, limit, values, year) => {
  return axios.get(
    API_URL +
      `jobs/${year}?limit=${limit}&page=${page}${
        values?.fieldtype && values?.searchval
          ? "&" + values.fieldtype + "=" + values.searchval
          : ""
      }`,
    {
      headers: headers2,
    }
  );
};

const getJobDetailByJob = (page, limit, values, job) => {
  return axios.get(
    API_URL +
      `job-detail/${job}?limit=${limit}&page=${page}${
        values?.fieldtype && values?.searchval
          ? "&" + values.fieldtype + "=" + values.searchval
          : ""
      }`,
    {
      headers: headers2,
    }
  );
};
const getJobDetailInfoByJob = (job) => {
  return axios.get(API_URL + `job-detail-info/${job}`, {
    headers: headers2,
  });
};

const uploadSheet = (values) => {
  return axios.post(
    API_URL +
      `upload-sheet-pyt
  `,
    values,
    {
      headers: headers,
    }
  );
};

const getNewsletter = (orderId) => {
  return axios.get(
    API_URL + `newsletter/${orderId}`,

    {
      headers: headers2,
    }
  );
};

const getFilesUploaded = (page, limit, values) => {
  return axios.get(
    API_URL +
      `uploaded-files?limit=${limit}&page=${page}${
        values?.fieldtype && values?.searchval
          ? "&" + values.fieldtype + "=" + values.searchval
          : ""
      }`,

    {
      headers: headers2,
    }
  );
};

const getFilesUploadedView = (id) => {
  return axios.get(
    API_URL + `file-records/${id}`,

    {
      headers: headers2,
    }
  );
};

const newsletterUpdate = (values, admin_id, id) => {
  return axios.put(
    API_URL + "newsletter/" + id,
    {
      subject: values.subject,
      body: he.encode(values.body),
      adminId: admin_id,
    },
    {
      headers: headers2,
    }
  );
};

const AdminListService = {
  loginAdmin,
  forgotPass,
  getCounts,
  latestOrder,
  getProfile,
  profileUpdate,
  orderArchive,
  getWebsiteInfo,
  websiteUpdate,
  getAllYears,
  deletSingleFile,
  deletAllFiles,
  getUsers,
  deletSingleOrders,
  deletSingleNote,
  deletAllOrders,
  archiveAllOrders,
  getOrdersById,
  updateUserById,
  voucherUnArchive,
  updateVoucherById,
  deletSingleVouchers,
  deleteCertificatesByType,
  getVouchers,
  voucherArchive,
  getVoucherById,
  getEmails,
  deletAllEmail,
  deletSingleEmail,
  getEmailById,
  updateEmailById,
  addEmail,
  getJobss,
  getJobDetailByJob,
  getJobDetailInfoByJob,
  uploadSheet,
  getNewsletter,
  newsletterUpdate,
  getFilesUploaded,
  getFilesUploadedView,
};

export default AdminListService;
